module.exports = __webpack_public_path__ + "media/store/images/arrow-60c86b796352b493e188f3f0ec0a752a.svg";